
















































































































































import { DateTime } from 'luxon';
import { Component, Vue } from 'vue-property-decorator';
import { list, addPatient, removePatients } from '@/api/manage';
import { PatientData, PatientRegistData } from '../../../common/dist/common';

@Component
export default class Manage extends Vue {
  public ids: number[] = [];
  public loading = false;
  public error?: string;
  public list: PatientData[] = [];
  public addDialog = false;
  public valid = false;
  public patientData: Partial<PatientRegistData> = {};
  public days = 0;
  public weeks = 0;
  public submitting = false;
  public addSuccess = false;
  public addErrorMessage = '';
  public addError = false;
  public removeSuccess = false;
  public removeError = false;
  public removeErrorMessage = '';

  public mounted() {
    this.load();
  }

  private async load() {
    this.loading = true;

    const ret = await list();
    if (ret.success) {
      this.list = ret.data;
    } else {
      this.error = ret.message;
    }

    this.loading = false;
  }

  // eslint-disable-next-line class-methods-use-this
  public getWeekDays(p: PatientData) {
    if (!p) {
      return '';
    }
    const begin = DateTime.fromISO(p.begin);
    const measuerDate = DateTime.local();
    const diff = measuerDate.diff(begin, 'days').shiftTo('weeks', 'days');
    return `${Math.floor(diff.weeks)} / ${Math.floor(diff.days)}`;
  }

  // eslint-disable-next-line class-methods-use-this
  public dateFormat(iso: string) {
    return DateTime.fromISO(iso).toLocaleString(
      DateTime.DATE_SHORT,
    );
  }

  public async onRegist() {
    this.submitting = true;

    const begin = DateTime.local()
      .minus({
        weeks: this.weeks,
        days: this.days,
      })
      .toUTC()
      .toJSDate();
    this.patientData.begin = begin.toISOString();

    const ret = await addPatient(this.patientData);
    if (ret.success) {
      this.addSuccess = true;
      this.addDialog = false;
    } else {
      this.addError = true;
      this.addErrorMessage = ret.message;
    }

    this.submitting = false;
    this.load();
  }

  public async onRemove() {
    this.submitting = true;
    const ret = await removePatients({
      ids: this.ids,
    });
    if (ret.success) {
      this.removeSuccess = true;
    } else {
      this.removeError = true;
      this.removeErrorMessage = ret.message;
    }
    this.submitting = false;
    this.load();
    this.ids = [];
  }
}
